<style lang="less" scoped>
div.login_bg {background: 0 0;height: auto;min-width: 1200px;position: relative;overflow: hidden;}
div.login_bg .login-bg-img {max-width: initial;position: relative;top: 0;left: 50%;-webkit-transform: translateX(-50%);transform: translateX(-50%);}
div.login_bg .layout {width: 1200px;margin: 0px auto;position: absolute;top: 0;left: 0;right: 0;}
div.login_bg .form_win {background: rgba(255, 255, 255, 0.74);border: 2px solid rgba(204, 204, 204, 0.75);top: 60px;}
div.login_bg .form_win .login_btn {font-weight: 700;}
div.login_bg .form_win .tabs {display: -webkit-box;display: -ms-flexbox;display: flex;height: 59px;line-height: 59px;margin-bottom: 20px;border-bottom: solid 1px #c8cbce;}
div.login_bg .form_win .tabs .tab-item {-webkit-box-flex: 1;-ms-flex: 1;flex: 1;text-align: center;font-size: 18px;border-right: solid 1px #c8cbce;cursor: pointer;}
div.login_bg .form_win .tabs .tab-item:last-child {border-right: none;}
div.login_bg .form_win .tabs .tab-item.active {color: #0090ff;}
div.login_bg .form_win .win_content {width: auto;padding-top: 0;}
div.login_bg .form_win .form-wrap {display: none;background: 0 0;}
div.login_bg .form_win .form-wrap.active, div.login_bg .form_win .form.active {display: block;}
.fl{ float: left;}
.hide {display: none;}
.login_bg {width: 100%;height: 582px;}
.login_bg .layout {position: relative;}
.form_win {width: 400px;height: auto;background: #FFFFFF;border-radius: 3px;position: absolute;right: 0;top: 150px;padding-bottom: 20px;}
.win_content {margin: 0 auto;width: 350px;padding-top: 30px;}
.win_content h3 {margin-bottom: 18px;color: #333333;}
.win_input {height: 40px;width: 100%;text-indent: 10px;margin-top: 8px;border: 1px solid #d5d5d5;}
.login_btn {display: block;width: 100%;height: 35px;line-height: 35px;text-align: center;background: #0090ff;border: none;color: #FFFFFF;margin-top: 30px;border-radius: 3px;}
.login_btn.disable {opacity: 0.5; cursor: default;}
.tip_p {color: #f00;font-size: 14px;}
.tip_p a {color: #333333;margin-top: 15px;}
.yanzhenginput {width: 220px;text-indent: 10px;margin-top: 8px;border: 1px solid #d5d5d5;height: 40px;}
.yanzhengmabtn {width: 120px;height: 40px;text-align: center;background: #f5f5f5;border: 1px solid #d5d5d5;font-size: 14px;}
li {list-style: none;}
</style>

<template>
  <div class="login_bg">
    <img src="../../../../static/images/loginbg.jpg" class="login-bg-img"/>
    <div class="layout">
      <div class="form_win">
        <div class="win_content">
          <div class="tabs">
            <li class="tab-item login-tab" @click="goTheLogin()" :class="current===0 ? 'active': ''">用户登录</li>
            <li class="tab-item register-tab" @click="goRegistered()" :class="current===1 ? 'active': ''">注册账号</li>
          </div>
          <TheLogin v-if="isTheLogin"></TheLogin>
          <Registered v-if="isRegistered"></Registered>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheLogin from './TheLogin.vue'
import Registered from './Registered.vue'
export default {
  components: {
    TheLogin,
    Registered
  },
  data()
  {
    return {
      isTheLogin: true,
      isRegistered: false,
      current: 0
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        if (nval.params.isFlag === '登录')
          this.goTheLogin()
        else if (nval.params.isFlag === '注册')
          this.goRegistered()
      },
      immediate: true
    }
  },
  methods: {
    goTheLogin()
    {
      this.current = 0
      this.isTheLogin = true
      this.isRegistered = false
    },
    goRegistered()
    {
      this.current = 1
      this.isRegistered = true
      this.isTheLogin = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/login/LoginIndex.vue